/* file description */

import React from 'react';
import UploadRenderItemMemo from './renderItem';
import RenderItem from './render';
import { COLUMN_FROM } from '../consts';
import { TransformRecord2TableColumn } from '../type';
import { Api as FetchAPI } from '@/utils';

export const transformUpload2TableColumn: TransformRecord2TableColumn = ({
  targetColumn,
  field,
  // ...others
}) => {
  // 编辑态
  targetColumn.renderFormItem = (_a, config, form) => {
    return <UploadRenderItemMemo field={field} FetchAPI={FetchAPI} form={form} config={config} columnFrom={config.from} />;
  };
  // 展示态
  targetColumn.render = (dom, entity) => {
    let fileType = '';
    const targerValue = entity?.value;
    if (targerValue) {
      const arr = targerValue.split('.');
      fileType = arr[arr.length - 1];
    }
    const { setViewValue } = entity;
    return <RenderItem targerValue={targerValue} fileType={fileType} setViewValue={setViewValue} />;
  };

  return targetColumn;
};
